/**
 * @author: lv.chen
 * @date: 2026/3/13
 * @desc: 系统级气泡组件，封装tea-component Bubble的通用配置
 */
import React from 'react';
import { Bubble as TeaBubble, BubbleProps as TeaBubbleProps } from 'tea-component';
import classnames from 'classnames';

import './index.scss';

interface IBubbleProps extends TeaBubbleProps {
  /** 是否禁用 */
  disabled?: boolean;
  /** 气泡最大宽度，默认500px */
  maxWidth?: number | string;
}

/**
 * 系统级气泡组件
 * 默认配置：黑色气泡、最大宽度500px、arrowPointAtCenter、closeOnScroll、dark模式
 * 字体样式：14px、白色、字重400、英文单词保持完整性
 */
const Bubble: React.FC<IBubbleProps> = (props) => {
  const {
    style,
    className,
    content,
    trigger = 'hover',
    placement = 'top',
    disabled = false,
    maxWidth = 500,
    dark = true,
    arrowPointAtCenter = true,
    closeOnScroll = true,
    children,
    ...restProps
  } = props;

  if (disabled || !content) {
    return <>{children}</>;
  }

  return (
    <TeaBubble
      {...restProps}
      style={{ ...style, maxWidth }}
      className={classnames('dbi-component-bubble', className)}
      dark={dark}
      arrowPointAtCenter={arrowPointAtCenter}
      closeOnScroll={closeOnScroll}
      trigger={trigger}
      placement={placement}
      content={content}
    >
      {children}
    </TeaBubble>
  );
};

export default Bubble;
